import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseData } from '../interfaces/response.interface';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class SendbirdChatApi extends BaseApi {
  registerChat(): Observable<ResponseData<{ userId: string; userName: string; accessToken: string; profile: string }>> {
    return this.post(`${environment.apiUrl}/v1/chat/chat/registerchat`);
  }

  getChatProfile(uid: string): Observable<
    ResponseData<{
      avatar: string;
      name: string;
      isInvisible: boolean;
      info: {
        registerDate: string;
        highestMultipler: number;
        highestMultiplerBetId: string;
        totalWins: number;
        totalWagered: number;
        tipsSent: number;
        tipsReceived: number;
      };
    }>
  > {
    return this.get(`${environment.apiUrl}/v1/chat/chat/getchatprofile`, {
      Uid: uid,
    });
  }

  /**
   * 拿取 Zendesk JWT
   *
   * @returns Observable
   */
  getZendeskJwt(): Observable<{ code: string; data: string; message: null | string; success: boolean }> {
    return this.get(`${environment.apiUrl}/v1/chat/chat/getzendesktoken`);
  }
}
